import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type {
  UtenteAutorizzato,
  UtenteAutorizzatoCreate,
  UtenteAutorizzatoUpdate,
} from "@/types/api";

export function useAdminUtenti() {
  return useQuery({
    queryKey: ["admin-utenti"],
    queryFn: () => apiFetch<UtenteAutorizzato[]>("/api/v1/admin/utenti"),
    staleTime: 30_000,
  });
}

export function useInvitaUtente() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UtenteAutorizzatoCreate) =>
      apiFetch<UtenteAutorizzato>("/api/v1/admin/utenti", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["admin-utenti"] }),
  });
}

interface ModificaArgs {
  email: string;
  body: UtenteAutorizzatoUpdate;
}

export function useModificaUtente() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ email, body }: ModificaArgs) =>
      apiFetch<UtenteAutorizzato>(
        `/api/v1/admin/utenti/${encodeURIComponent(email)}`,
        {
          method: "PATCH",
          body: JSON.stringify(body),
        }
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["admin-utenti"] }),
  });
}

export function useRevocaUtente() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) =>
      apiFetch<void>(`/api/v1/admin/utenti/${encodeURIComponent(email)}`, {
        method: "DELETE",
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["admin-utenti"] }),
  });
}

export function useReinviaMagicLink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) =>
      apiFetch<UtenteAutorizzato>(
        `/api/v1/admin/utenti/${encodeURIComponent(email)}/reinvia`,
        { method: "POST" }
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["admin-utenti"] }),
  });
}
